export const autoSchedulingStatuses = {
  BUSY: 'BUSY',
  IDLE: 'IDLE',
  COMPLETED: 'COMPLETED',
  ABORTED: 'ABORTED',
};
